import { ShowHeaderType } from 'views/constants/enums/ShowHeaderType';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';

//　ヘッダーが存在していいパスかチェックする関数
export const checkHeaderPath = (path: string) => {
  switch (path) {
    case CustomerPagePath.Login:
    case CustomerPagePath.SendSMS:
    case CustomerPagePath.ReissuePassword:
    case CustomerPagePath.Maintenance:
    case CustomerPagePath.MFARedirect:
      return ShowHeaderType.None;
    case CustomerPagePath.AddvanceQuestion:
    case CustomerPagePath.ConsentSecurities:
    case CustomerPagePath.ConsentTrust:
    case CustomerPagePath.CustomerInfo:
    case CustomerPagePath.DepositAccount:
    case CustomerPagePath.Employment:
    case CustomerPagePath.InvestmentInfo:
    case CustomerPagePath.RequestConfirm:
    case CustomerPagePath.RequestComplete:
      return ShowHeaderType.Bar;
    default:
      return ShowHeaderType.Info;
  }
};

// パスキー案内を出すパスかチェック
export const checkPasskeySuggestHeader = (path: string) => {
  switch (path) {
    case CustomerPagePath.Home:
      return true;
    default:
      return false;
  }
};
